import { render, staticRenderFns } from "./InterventiTabella.vue?vue&type=template&id=b9901e66&"
import script from "./InterventiTabella.vue?vue&type=script&lang=js&"
export * from "./InterventiTabella.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports